module.exports = __webpack_public_path__ + "media/images/athletes/1764-46a9958d4feb69c3749e5ecb68bf0862.png";